import { type ReactNode, useEffect } from "react";
import { Icon } from "@/components/Icon/Icon";

type ModalShellProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  eyebrow?: string;
  accentVar?: string;
  width?: number;
  children: ReactNode;
};

export function ModalShell({
  open,
  onClose,
  title,
  subtitle,
  eyebrow,
  accentVar,
  width = 880,
  children,
}: ModalShellProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-scrim" onClick={onClose}>
      <div
        className="modal-shell"
        onClick={(e) => e.stopPropagation()}
        style={{ width: `min(92vw, ${width}px)` }}
      >
        <div
          className="modal-header"
          style={{
            borderTop: accentVar ? `3px solid ${accentVar}` : undefined,
          }}
        >
          <div className="vstack" style={{ flex: 1, gap: 4, minWidth: 0 }}>
            {eyebrow && <span className="modal-eyebrow">{eyebrow}</span>}
            <div className="modal-title">{title}</div>
            {subtitle && <div className="modal-subtitle">{subtitle}</div>}
          </div>
          <button
            type="button"
            className="btn xs ghost"
            onClick={onClose}
            style={{ padding: 6 }}
          >
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
